<template>
  <div>
    <div class="row" style="padding-top: 125px">
      <div class="col-md-4">
        <b-img-lazy
          v-for="image in images1"
          :key="image.src"
          :src="image.src"
          fluid
          class="thumbnail"
        />
      </div>
      <div class="col-md-4">
        <b-img-lazy
          v-for="image in images2"
          :key="image.src"
          :src="image.src"
          fluid
          class="thumbnail"
        />
      </div>
      <div class="col-md-4">
        <b-img-lazy
          v-for="image in images3"
          :key="image.src"
          :src="image.src"
          fluid
          class="thumbnail"
        />
      </div>
    </div>
    <div class="row" style="padding-bottom: 25px; padding-left: 20px">
      <a href="https://www.linkedin.com/in/joshscurtis/" target="_blank" rel="noopener">
        <img
          src="../assets/li.png"
          height="45px"
          style="padding-right: 10px"
          alt="LinkedIn"
        />
      </a>
      <a href="https://github.com/joshscurtis" target="_blank" rel="noopener" class="social-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
        </svg>
      </a>
      <a href="https://www.instagram.com/cowboycurtis__/" target="_blank" rel="noopener">
        <img src="../assets/ig.png" width="45px" height="45px" alt="Instagram" style="padding-left: 10px" />
      </a>
    </div>
  </div>
</template>

<script>
import { filterStore } from "@/store/filterStore";

// NOTE: webpack's require.context needs literal arguments (folder + regex)
// so it can statically extract dependencies at build time. Do not hoist the
// regex or folder path into variables or the context will be empty at runtime.
function loadCategory(ctx, category) {
  return ctx.keys().map((key) => ({
    src: ctx(key),
    category,
    key: `${category}:${key}`,
  }));
}

export default {
  name: "HomePage",
  data() {
    return {
      shuffledImages: [],
    };
  },
  created() {
    const galleryCtx = require.context("@/assets/gallery", false, /\.(png|jpe?g|gif|webp)$/i);
    const adventureCtx = require.context("@/assets/adventure", false, /\.(png|jpe?g|gif|webp)$/i);
    const motorcycleCtx = require.context("@/assets/motorcycle", false, /\.(png|jpe?g|gif|webp)$/i);
    const creationsCtx = require.context("@/assets/creations", false, /\.(png|jpe?g|gif|webp)$/i);

    const allImages = [
      ...loadCategory(galleryCtx, "uncategorized"),
      ...loadCategory(adventureCtx, "adventure"),
      ...loadCategory(motorcycleCtx, "motorcycle"),
      ...loadCategory(creationsCtx, "creator"),
    ];

    this.shuffledImages = this.shuffleArray(allImages);
  },
  computed: {
    activeFilter() {
      return filterStore.activeFilter;
    },
    filteredImages() {
      if (!this.activeFilter) return this.shuffledImages;
      return this.shuffledImages.filter(
        (img) => img.category === this.activeFilter
      );
    },
    images1() {
      return this.distributeImages(0);
    },
    images2() {
      return this.distributeImages(1);
    },
    images3() {
      return this.distributeImages(2);
    },
  },
  methods: {
    shuffleArray(array) {
      const shuffled = [...array];
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    },
    distributeImages(columnIndex) {
      return this.filteredImages.filter((_, index) => index % 3 === columnIndex);
    },
  },
};
</script>

<style scoped>
.thumbnail {
  width: 100%;
  padding: 0px;
  border: 0px solid #4d4e62;
}

a {
  text-decoration: none;
}

.social-icon {
  display: inline-flex;
  vertical-align: middle;
}

.social-icon svg {
  fill: #aaaaaa;
  transition: fill 0.2s;
}

.social-icon:hover svg {
  fill: #e0e0e0;
}
</style>
